import React from "react";
import {observer} from "mobx-react-lite";

const Settings = () => {
    return (
        <div>
            <h1>Settings</h1>
        </div>
    )
}
export default observer(Settings)